import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider } from './contexts/AuthContext'
import { LanguageProvider } from './contexts/LanguageContext'
import { ThemeProvider } from './contexts/ThemeContext'
import ExploreLayout from './components/ExploreLayout'
import CreatorStudioLayout from './components/CreatorStudioLayout'
import MapExplore from './pages/MapExplore'
import DiscoverPage from './pages/DiscoverPage'
import LandingPage from './pages/LandingPage'
import LoginPage from './pages/LoginPage'
import SignupPage from './pages/SignupPage'
import ProfilePage from './pages/ProfilePage'
import UserBioPage from './pages/UserBioPage'
import TermsOfServicePage from './pages/TermsOfServicePage'
import PrivacyPolicyPage from './pages/PrivacyPolicyPage'
import AdminPage from './pages/AdminPage'
import CreatorStudioPage from './pages/CreatorStudioPage'
import ImportContentPage from './pages/ImportContentPage'
import POILandingPage from './pages/POILandingPage'
import ListTourPage from './pages/ListTourPage'
import ListsPage from './pages/ListsPage'
import ListDetailPage from './pages/ListDetailPage'

function App() {
  return (
    <BrowserRouter>
      <ThemeProvider>
        <AuthProvider>
          <LanguageProvider>
            <Routes>
              <Route path="/login" element={<LoginPage />} />
              <Route path="/signup" element={<SignupPage />} />
              <Route path="/profile" element={<ProfilePage />} />
              <Route path="/user/:userId" element={<UserBioPage />} />
              <Route path="/terms" element={<TermsOfServicePage />} />
              <Route path="/privacy" element={<PrivacyPolicyPage />} />
              <Route path="/admin" element={<AdminPage />} />
              <Route path="/import" element={<ImportContentPage />} />
              <Route path="/app/list/:listUuid" element={<ListTourPage />} />
              <Route path="/app/:poiUuid" element={<POILandingPage />} />
              <Route path="/lists" element={<ListsPage />} />
              <Route path="/lists/:uuid" element={<ListDetailPage />} />
              <Route path="/creator-studio/*" element={
                <CreatorStudioLayout>
                  <Routes>
                    <Route path="/" element={<CreatorStudioPage />} />
                    <Route path="/map" element={<CreatorStudioPage />} />
                    <Route path="*" element={<CreatorStudioPage />} />
                  </Routes>
                </CreatorStudioLayout>
              } />
              <Route path="/discover" element={
                <ExploreLayout>
                  <DiscoverPage />
                </ExploreLayout>
              } />
              <Route path="/" element={<LandingPage />} />
              <Route path="/creator/*" element={
                <ExploreLayout>
                  <Routes>
                    <Route path="/" element={<MapExplore />} />
                    <Route path="*" element={<MapExplore />} />
                  </Routes>
                </ExploreLayout>
              } />
              <Route path="/*" element={<Navigate to="/" replace />} />
            </Routes>
          </LanguageProvider>
        </AuthProvider>
      </ThemeProvider>
    </BrowserRouter>
  )
}

export default App